<template>
    <div v-if="user.desk_required === 'none'">
        <button-secondary @click="open">
            <i class="fa fa-calendar mr-2"></i> Kalender bearbeiten
        </button-secondary>

        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>Kalender bearbeiten</template>

                <loading v-show="loading"></loading>

                <div class="flex justify-center" v-show="!loading">
                    <button-secondary @click="prev" class="mr-2">
                        <i class="fa fa-minus mr-2"></i> Vorherige Woche
                    </button-secondary>
                    <button-secondary @click="next">
                        <i class="fa fa-plus mr-2"></i> Nächste Woche
                    </button-secondary>
                </div>

                <tailwind-table :header="['Datum', 'Status', '']" v-show="!loading">
                    <tr v-for="day in days" :key="day">
                        <td class="px-6 py-3">
                            {{ format(day) }}
                        </td>
                        <td class="px-6 py-3">
                            <span v-show="!hasRelease(day)">
                                im Büro
                            </span>
                            <span v-show="hasRelease(day)">
                                außer Haus
                            </span>
                        </td>
                        <td class="px-6 py-3">
                            <button-white v-show="!hasRelease(day)" @click="create(day)">
                                Schreibtisch freigeben!
                            </button-white>
                            <button-link v-show="hasRelease(day)" @click="remove(day)">Freigabe zurückziehen.</button-link>
                        </td>

                    </tr>
                </tailwind-table>

            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonSecondary from "../UI/ButtonSecondary.vue";
import Modal from "../Modal.vue";
import Loading from "../UI/Loading.vue";
import {addDays, subDays} from "date-fns";
import TailwindTable from "../UI/TailwindTable.vue";
import ButtonLink from "../UI/ButtonLink.vue";
import ButtonWhite from "../UI/ButtonWhite.vue";

export default {
    name: "UserCalendar",

    components: {
        ButtonWhite,
        ButtonLink,
        TailwindTable,
        Loading,
        Modal,
        ButtonSecondary,
    },

    props: ['user'],

    data: () => ({
        showModal: false,
        loading: false,
        startDay: new Date(),
        releases: [],
    }),

    computed: {
        days() {
            const today = this.startDay;

            return [
                addDays(today, 0),
                addDays(today, 1),
                addDays(today, 2),
                addDays(today, 3),
                addDays(today, 4),
                addDays(today, 5),
                addDays(today, 6),
            ].map(day => {
                return day.toISOString().substring(0, 10);
            })
        },
    },

    mounted() {
        this.startDay = this.getStartMonday();
    },

    methods: {
        next() {
            this.startDay = addDays(this.startDay, 7);
        },
        prev() {
            this.startDay = subDays(this.startDay, 7);
        },
        getStartMonday() {
            let date = new Date();
            while (date.getDay() !== 1) {
                date = subDays(date, 1);
            }
            return date;
        },
        format(day) {
            const [y, m, d] = day.split('-');
            const dow = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'][new Date(day).getDay()];
            return `${dow} ${d}.${m}`;
        },
        hasRelease(day) {
            return this.releases.find(r => r.day === day) !== undefined;
        },
        open() {
            this.showModal = true;
            this.loading = true;
            this.$http.get(`/admin/users/${this.user.id}/days`).then(response => {
                this.loading = false;
                this.releases = response.data.data;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
        create(day) {
            this.loading = true;
            this.$http.post(`/admin/users/${this.user.id}/days`, {
                day: day,
            }).then(() => {
                this.open();
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
        remove(day) {
            const release = this.releases.find(r => r.day === day);
            const id = release.id;
            this.loading = true;
            this.$http.delete(`/admin/users/${this.user.id}/days/${id}`).then(() => {
                this.open();
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
    }

}
</script>

<style scoped>

</style>
